import { render, staticRenderFns } from "./WowzaEventChart.vue?vue&type=template&id=22705220&scoped=true"
import script from "./WowzaEventChart.vue?vue&type=script&lang=js"
export * from "./WowzaEventChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22705220",
  null
  
)

export default component.exports